import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDatepickerInputEvent, MatDialog, MatPaginator, MatSort, MatTableDataSource, PageEvent } from '@angular/material';
import { Router } from "@angular/router";
import { NotificationsService } from "angular2-notifications";
import * as moment from 'moment';
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import * as XLSX from 'xlsx';
import { TransactionService } from '../services/transaction.service';
import { UserService } from "../services/user.service";
import { AddEditDepositDialog } from './add-deposit/add-deposit.component';
import { SentReceiveINRDialog } from './sent-receive-inr/sent-receive-inr.component';

@Component({
  selector: 'app-client-transactions',
  templateUrl: './client-transactions.component.html',
  styleUrls: ['./client-transactions.component.css']
})
export class ClientTransactionsComponent implements OnInit {
  selectedClient: string = 'ALL';
  displayedColumns = [
    'action',
    'sell_receive_inr_action',
    'client',
    'transaction_date',
    'transaction_type',
    'amount',
    'price',
    'gross_amount',
    'tds1p',
    'net_amount',
    'remaining_inr',
    'remaining_usdt',
    'inr_sent_received',
    'usdt_sent_received',
    'deposit_id',
    'createdAt'
  ];
  displayedColumns1 = [
    'date',
    'type',
    'currency',
    'amount',
    'price',
    'net_amount',
    'transaction_ref',
    'note',
    'createdAt',
    'transaction_id',
  ];
  isClientBatch: boolean = false;
  filter: any = {
    fDate: moment().subtract(7, 'd').format('yyyy-MM-DD'),
    tDate: moment().format('yyyy-MM-DD')
  };
  dataSource: MatTableDataSource<any>;
  dataSource1: MatTableDataSource<any>;
  pageSize = 25;
  pageSize1 = 25;
  currentPage = 0;
  currentPage1 = 0;
  pageSizeOptions: number[] = [5, 10, 25, 50, 100];
  pageSizeOptions1: number[] = [5, 10, 25, 50, 100];
  @ViewChild('paginator', { read: MatPaginator }) paginator: MatPaginator;
  @ViewChild('paginator1', { read: MatPaginator }) paginator1: MatPaginator;
  @ViewChild('sort', { read: MatSort }) sort: MatSort;
  @ViewChild('sort1', { read: MatSort }) sort1: MatSort;

  permission: String;

  constructor(private notifSer: NotificationsService,
    private userService: UserService,
    private spinnerService: Ng4LoadingSpinnerService,
    private router: Router,
    private service: TransactionService,
    public dialog: MatDialog,
    private notif: NotificationsService) { }

  ngOnInit() {
    this.csrf();
  }
  csrf() {
    this.userService.csrf().subscribe((success) => {
      this.filter._csrf = success._csrf;

      this.getAll();
    }, (error) => {
      if (error.status > 0) {
        this.notif.error(
          'CSRF',
          error.error.message,
          {
            timeOut: 5000,
            showProgressBar: true,
            pauseOnHover: true,
            clickToClose: true,
            maxLength: 50
          }
        )
      }
    })
  }

  fromDateFilter(event: MatDatepickerInputEvent<Date>) {
    this.filter['fDate'] = moment(event.value).format('yyyy-MM-DD');
  }
  toDateFilter(event: MatDatepickerInputEvent<Date>) {
    this.filter['tDate'] = moment(event.value).format('yyyy-MM-DD');
  }
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }
  async pageChanged(event: PageEvent) {
    this.pageSize = await event.pageSize;
    this.currentPage = await event.pageIndex;
  }
  async pageChanged1(event: PageEvent) {
    this.pageSize1 = await event.pageSize;
    this.currentPage1 = await event.pageIndex;
  }
  addDeposit(element: any = {}, type: any, currency: any) {
    let obj = {
      ...element,
      type,
      currency
    }
    this.dialog.open(AddEditDepositDialog, {
      width: 'auto',
      data: obj,
    }).afterClosed().subscribe(result => {
      if (result) {
        this.getAll();
      }
    });
  }
  clientTxnExport() {
    this.service.clientTransactionReport(this.filter).subscribe((response: any) => {
      if (response.success && response.data) {
        const workbook = XLSX.utils.book_new();
        const summaryList = [];
        const depositSummary: Record<string, number> = {};

        for (const clientKey in response.data) {
          const transactions = response.data[clientKey];
          const exportList = [];

          transactions.forEach((txn: any) => {
            let txnTotalAmount = 0;

            if (txn.remaining_inr && txn.transaction_type) {
              const clientName = txn.client || '';
              const amount = Math.abs(Number(txn.remaining_inr));

              if (!depositSummary[clientName]) {
                depositSummary[clientName] = 0;
              }
              if (txn.transaction_type === 'Deposit') {
                depositSummary[clientName] += amount;
              } else if (txn.transaction_type === 'Withdraw') {
                depositSummary[clientName] -= amount;
              }
            }

            if (txn.batchDetails && txn.batchDetails.length > 0) {
              txn.batchDetails.forEach((batch: any, index: number) => {
                const amount = Number(batch.amount || 0);
                txnTotalAmount += amount;

                exportList.push({
                  'Transaction Date': index === 0 ? (txn.transaction_date ? new Date(txn.transaction_date).toLocaleString() : '') : '',
                  'Client': index === 0 ? (txn.client || '') : '',
                  'Txn Type': index === 0 ? (txn.transaction_type || '') : '',
                  'Deposit': index === 0 ? txn.inr_sent_received : '',
                  'Txn Amount': index === 0 ? (txn.amount || '') : '',
                  'Txn Price': index === 0 ? (txn.price || '') : '',
                  'Settle Amount': index === 0 ? txn.net_amount : '',
                  'Remain INR': index === 0 ? txn.remaining_inr : '',
                  ' ': '',
                  'Currency': batch.currency,
                  'Amount': amount,
                  'Price': batch.price || '',
                  'Net Amount': batch.net_amount || '',
                  'Type': batch.type || '',
                  'Transaction Ref': batch.transaction_ref || '',
                  'Date': batch.date ? new Date(batch.date).toLocaleString() : ''
                });
              });

              // Add total row
              exportList.push({
                'Transaction Date': '',
                'Client': '',
                'Txn Type': '',
                'Deposit': '',
                'Txn Amount': '',
                'Txn Price': '',
                'Settle Amount': '',
                'Remain INR': '',
                ' ': 'Total',
                'Currency': '',
                'Amount': txnTotalAmount,
                'Price': '',
                'Net Amount': '',
                'Type': '',
                'Transaction Ref': '',
                'Date': ''
              });
            } else {
              exportList.push({
                'Transaction Date': txn.transaction_date ? new Date(txn.transaction_date).toLocaleString() : '',
                'Client': txn.client || '',
                'Txn Type': txn.transaction_type || '',
                'Deposit': txn.inr_sent_received || '',
                'Txn Amount': txn.amount || '',
                'Txn Price': txn.price || '',
                'Settle Amount': txn.net_amount || '',
                'Remain INR': txn.remaining_inr || '',
                ' ': '', // 👈 Same here for consistency
                'Currency': '',
                'Amount': '',
                'Price': '',
                'Net Amount': '',
                'Type': '',
                'Transaction Ref': '',
                'Date': ''
              });
            }

          });

          const sheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportList);
          XLSX.utils.book_append_sheet(workbook, sheet, clientKey);
        }

        // Summary sheet
        for (const client in depositSummary) {
          const total = depositSummary[client];
          if (total !== 0) {
            summaryList.push({
              'Client': client,
              'Remain INR': total,
              'Action': 'Pending'
            });
          }
        }

        if (summaryList.length > 0) {
          const summarySheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(summaryList);
          XLSX.utils.book_append_sheet(workbook, summarySheet, 'Summary');
        }

        XLSX.writeFile(workbook, 'Client_Transaction_Report.xlsx');
      }
    });
  }



  addINRDeposit(element: any = {}, type: any, currency: any) {
    let obj = {
      ...element,
      type,
      currency
    }
    this.dialog.open(AddEditDepositDialog, {
      width: 'auto',
      data: obj,
    }).afterClosed().subscribe(result => {
      if (result) {
        this.getAll();
      }
    });
  }
  sendReceiveINR(_id: any, amount: any, currency: any, type: any) {
    let obj = {
      _id,
      amount,
      currency,
      type,
    }
    this.dialog.open(SentReceiveINRDialog, {
      width: 'auto',
      data: obj,
    }).afterClosed().subscribe(result => {
      if (result) {
        this.getAll();
      }
    });
  }

  selectClientData(event: any) {
    this.selectedClient = event.value;
    console.log('Selected client:', this.selectedClient);
    this.filter['client'] = this.selectedClient
  }

  clientINRTransaction(id) {
    this.isClientBatch = true
    this.service.getClientINRBatches(id).subscribe((response) => {
      if (response) {
        let data = response.map(d => {
          d.date = moment(d.date).format('MM/DD/YY');
          d.createdAt = moment(d.createdAt).format('MM/DD/YY h:mm:ss A');
          return d;
        })
        this.dataSource1 = new MatTableDataSource(data);
        this.dataSource1.paginator = this.paginator1
        this.dataSource1.sort = this.sort1;
      }
    });
  }
  getAll() {
    this.service.getClientTransaction(this.filter).subscribe((response) => {
      if (response) {
        let data = response.map(d => {
          d.transaction_date = moment(d.transaction_date).format('MM/DD/YY');
          d.createdAt = moment(d.createdAt).format('MM/DD/YY h:mm:ss A');
          return d;
        })
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.paginator = this.paginator
        this.dataSource.sort = this.sort;
      }
    });
  }

  exportExcel(ref: string) {
    this.service.getClientTransaction(this.filter).subscribe((success) => {
      if (success.status) {
        let exportreflist = [];
        for (let i = 0; i < success.deposit.length; i++) {
          exportreflist.push({
            'Client': success.deposit[i].client ? success.deposit[i].client : '',
            'TransactionDate': success.deposit[i].transaction_date ? success.deposit[i].transaction_date : '',
            'TransactionType': success.deposit[i].transaction_type ? success.deposit[i].transaction_type : '',
            'Amount': success.deposit[i].amount ? success.deposit[i].amount : '',
            'Price': success.deposit[i].price ? success.deposit[i].price : '',
            'GrossAmount': success.deposit[i].gross_amount ? success.deposit[i].gross_amount : '',
            'tds1p': success.deposit[i].tds1p ? success.deposit[i].tds1p : '',
            'NetAmount': success.deposit[i].net_amount ? success.deposit[i].net_amount : '',
            'INRSentReceived': success.deposit[i].inr_sent_received ? success.deposit[i].inr_sent_received : '',
            'USDTSentReceived': success.deposit[i].usdt_sent_received ? success.deposit[i].usdt_sent_received : '',
            'DepositId': success.deposit[i].deposit_id ? success.deposit[i].deposit_id : '',
            'CreatedAt': success.deposit[i].createdAt ? success.deposit[i].createdAt : '',
          })
        }
        let fileName = 'Client Transaction Report.xlsx';
        console.log(exportreflist)
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportreflist);
        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        /* save to file */
        XLSX.writeFile(wb, fileName);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/client-transactions/client-transactions.component.ts